import { createRoot } from 'react-dom/client';
import { useUnmount } from 'react-use';

import Dialog from '@/components/Dialog';

const root = createRoot(document.getElementById('dialog') as HTMLElement);

const useDialog = () => {
  const render = (element: any) => {
    root.render(
      <Dialog
        isOpen
        content={element}
        title="Importante"
        onClose={() => removeDialog()}
      />
    );
  };

  const removeDialog = () => {
    root.render(null);
  };

  useUnmount(() => removeDialog());

  return { render, removeDialog };
};

export default useDialog;
